import { faLocationCrosshairs } from "@fortawesome/pro-regular-svg-icons"
import { CoreButton } from "component/w24/component/CoreButton"
import { CoreButton2 } from "component/w24/component/CoreButton2"
import { W1 } from "component/w24/component/W1"
import { Localization } from "libs/localization/localization"
import { EVariables } from "libs/style/w24_styling"
import { useIsWide } from "libs/utils/logic/responsiveLogic"
import React from "react"
import { Link as Link2 } from "react-scroll"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const LandingFooter = (props: Props): JSX.Element => {
  const isWide = useIsWide()

  return (
    <S_LandingFooter className={props.className}>
      <S_W1>
        {isWide && (
          <>
            {Localization.FOOTER1} {Localization.FOOTER2}
          </>
        )}
        {!isWide && (
          <>
            {Localization.FOOTER1}
            <br /> {Localization.FOOTER2}
          </>
        )}
      </S_W1>
      <S_Buttons>
        <S_Button1
          to="contact"
          spy={true}
          smooth={true}
          offset={-50}
          duration={500}
        >
          <S_CoreButton
            title={Localization.ACTION1}
            icon={faLocationCrosshairs}
          />
        </S_Button1>
        {/* <S_Button2
          href="https://app.mapheim.com/"
          target="_blank"
          rel="noreferrer"
        >
          <S_CoreButton2 title={Localization.ACTION2} badge="BETA" />
        </S_Button2> */}
      </S_Buttons>
    </S_LandingFooter>
  )
}

const S_LandingFooter = styled.div`
  width: 100%;
  height: 323px;
  border-radius: ${EVariables.Radius2};
  background-color: linear-gradient(180deg, rgba(203, 225, 244, 1) 0%, #f99a6d);
  background-image: url("/footer_mobile.jpg");
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding: 38px 25px 25px 25px;
  justify-content: space-between;
  @media only screen and (min-width: 1260px) {
    height: 350px;
    padding: 65px 67px;
    background-image: url("/footer.jpg");
  }
`

const S_W1 = styled(W1)``

const S_Buttons = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 1260px) {
    flex-direction: row;
  }
`

const S_CoreButton = styled(CoreButton)``

const S_CoreButton2 = styled(CoreButton2)`
  margin: 20px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 0 0 0 30px;
  }
`

const S_Button1 = styled(Link2)`
  margin: 43px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 100px 0 0 0;
  }
`

const S_Button2 = styled.a`
  margin: 0px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 100px 0 0 0px;
  }
`
